"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function createUseDataLayerApi(ApiContext) {
    return function useDataLayerApi() {
        var dataLayerApi = react_1.useContext(ApiContext);
        if (!dataLayerApi) {
            throw Error('Looks like DataLayer.useApi() is called outside of DataLayerProvider');
        }
        return dataLayerApi;
    };
}
exports.createUseDataLayerApi = createUseDataLayerApi;
